import { Input, SubmitButton, SubmitButtonsLine } from 'components';
import { Session, SessionLink, useUpdateSessionLink } from 'queries';
import { CountryIncentiveDisplay } from '../components/CountryIncentiveDisplay';
import { Form, Formik } from 'formik';
import { useFormikSubmit } from 'hooks/useFormikSubmit';

interface Props {
  session: Session;
  sessionLink: SessionLink;
  onSuccess?: () => any;
}

export const SessionLinkIncentiveEdition = ({
  session,
  sessionLink,
  onSuccess,
}: Props) => {
  const { mutateAsync: updateSessionLink } = useUpdateSessionLink(
    sessionLink.id,
  );

  const [initialValues, submit] = useFormikSubmit(
    updateSessionLink,
    sessionLink,
    undefined,
    { onSuccess },
  );

  return (
    <Formik initialValues={initialValues} onSubmit={submit}>
      <Form>
        <CountryIncentiveDisplay
          session={session}
          duration={session.duration}
          sessionLinkId={sessionLink.id}
          overGray
        />

        <Input
          name="incentiveText"
          label="Surcharger la contrepartie pour tout le monde"
        />

        <SubmitButtonsLine>
          <SubmitButton text="Sauvegarder" small />
        </SubmitButtonsLine>
      </Form>
    </Formik>
  );
};
